<template>
  <header class="fixed-header w-100" ref="fixedHeader">
    <div class="container-fluid" id="content-container">
      <div class="text-center letters-block">
        <HeaderLetters/>
      </div>
      <hr class="top-line"/>
      <div class="text-center fixed-header-container m-auto">
        <Navigation/>
      </div>
      <hr class="mt-2 mt-md-3">
    </div>
  </header>
</template>

<script>
import HeaderLetters from '@/components/Header/HeadLetters'
import Navigation from '@/components/Header/Navigation'

export default {
  name: 'FixedHeader',
  components: {
    HeaderLetters,
    Navigation
  }
}
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";
  @import "../../common.scss";

  .fixed-header {
    width: 100%;
  }
  .fixed-header-container {
    max-width: 900px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/FixedHeader.vue